import React from 'react'
import './App.css'
import Routing from './components/Routing'
import { PublicIndexProvider } from './context/PublicIndexProvider'

function App () {
  return (
    <div>
      <PublicIndexProvider>
        <Routing />
      </PublicIndexProvider>
    </div>
  )
}

export default App
